module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/synth-v2-28928c6175c1d59142fb52fe695c2351.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/synth-v2.svg
// module id = aQsK
// module chunks = 1 3 10 12 18